import { useCallback, useMemo, useState } from 'react';
import { OrderDetailsActions } from '../actions/order-details.actions';
import { useQueryGetOrderTimeline } from '../order-details.queries';
import { useQueryGetOrder } from '../../orders.queries';
import { useQueryClient } from 'react-query';
import { QueryKeys } from '../../../../core/queries/query-keys.constants';

interface OrderDetailsPageState {
  currentAction: OrderDetailsActions | null;
}

const initialState: OrderDetailsPageState = {
  currentAction: null
};

export function useOrderDetails(retailerID: string, orderID: string) {
  const [state, setState] = useState(initialState);

  const client = useQueryClient();
  const order = useQueryGetOrder(retailerID, orderID);
  const timeline = useQueryGetOrderTimeline(retailerID, orderID);

  function setAction(action: OrderDetailsActions | null) {
    setState((state) => ({ ...state, currentAction: action }));
  }

  const endAction = useCallback((nextAction?: OrderDetailsActions) => {
    setAction(nextAction || null);
    client.invalidateQueries([QueryKeys.ORDERS, retailerID, orderID]);
  }, []);

  const handlers = useMemo(
    () => ({
      setAction,
      endAction
    }),
    [endAction]
  );

  return { order, timeline, state, handlers } as const;
}
